(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-showcase"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[class*="bsc-"] .bsc-track').forEach(function (track) {
    var root = track.closest('[class*="bsc-"]');
    var progress = root.querySelector('[data-bsc-progress]');
    var cards = track.querySelectorAll('.bsc-card');
    if (!progress || !cards.length) return;

    cards.forEach(function (_, i) {
      var dot = document.createElement('span');
      if (i === 0) dot.className = 'is-active';
      progress.appendChild(dot);
    });
    var dots = progress.querySelectorAll('span');

    track.addEventListener('scroll', function () {
      var index = Math.round(track.scrollLeft / cards[0].offsetWidth);
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interactive-hero-autoplay"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[class*="ihc-"][data-autoplay]').forEach(function (root) {
    var dots = root.querySelectorAll('[data-dot]');
    var heroImg = root.querySelector('[data-hero-img]');
    var heroOverlay = root.querySelector('[data-hero-overlay]');
    var heroGlow = root.querySelector('[data-hero-glow]');
    var heroTag = root.querySelector('[data-hero-tag]');
    var heroTitle = root.querySelector('[data-hero-title]');
    var heroCta = root.querySelector('[data-hero-cta]');
    var speed = (parseFloat(root.dataset.autoplay) || 4) * 1000;
    var current = 0;
    var timer = null;
    var colorCache = {};

    function getDominantColor(imgEl, callback) {
      if (colorCache[imgEl.src]) {
        callback(colorCache[imgEl.src]);
        return;
      }
      var canvas = document.createElement('canvas');
      var w = 40, h = 40;
      canvas.width = w;
      canvas.height = h;
      var ctx = canvas.getContext('2d');
      try {
        ctx.drawImage(imgEl, 0, 0, w, h);
        var data = ctx.getImageData(0, 0, w, h).data;
        var r = 0, g = 0, b = 0, count = 0;
        for (var i = 0; i < data.length; i += 4) {
          r += data[i];
          g += data[i + 1];
          b += data[i + 2];
          count++;
        }
        r = Math.round(r / count);
        g = Math.round(g / count);
        b = Math.round(b / count);
        var darkR = Math.round(r * 0.45);
        var darkG = Math.round(g * 0.45);
        var darkB = Math.round(b * 0.45);
        var lightR = Math.round(r + (255 - r) * 0.85);
        var lightG = Math.round(g + (255 - g) * 0.85);
        var lightB = Math.round(b + (255 - b) * 0.85);
        var luminance = (r * 299 + g * 587 + b * 114) / 1000;
        var textColor = luminance > 140 ? '#1a1a1a' : '#ffffff';
        var textColorSoft = luminance > 140 ? 'rgba(26,26,26,0.7)' : 'rgba(255,255,255,0.75)';
        var result = {
          base: 'rgb(' + r + ',' + g + ',' + b + ')',
          dark: 'rgb(' + darkR + ',' + darkG + ',' + darkB + ')',
          light: 'rgb(' + lightR + ',' + lightG + ',' + lightB + ')',
          text: textColor,
          textSoft: textColorSoft
        };
        colorCache[imgEl.src] = result;
        callback(result);
      } catch (e) {
        callback({ base: '#4A1B0C', dark: '#2C1006', light: '#F5E6DE', text: '#ffffff', textSoft: 'rgba(255,255,255,0.75)' });
      }
    }

    function applyGlobalTheme(color) {
      var root = document.documentElement;
      root.style.setProperty('--dynamic-bg', color.base);
      root.style.setProperty('--dynamic-bg-dark', color.dark);
      root.style.setProperty('--dynamic-bg-light', color.light);
      root.style.setProperty('--dynamic-accent', color.base);
      root.style.setProperty('--dynamic-text', color.text);
      root.style.setProperty('--dynamic-text-soft', color.textSoft);
    }

    function revealWords(el, text) {
      el.innerHTML = '';
      var words = text.split(' ');
      words.forEach(function (w, i) {
        var span = document.createElement('span');
        span.className = 'ihc-word';
        span.textContent = w + (i < words.length - 1 ? '\u00A0' : '');
        span.style.transitionDelay = (i * 70) + 'ms';
        el.appendChild(span);
      });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.querySelectorAll('.ihc-word').forEach(function (s) { s.classList.add('is-in'); });
        });
      });
    }

    function activate(index) {
      var dot = dots[index];
      if (!dot) return;
      current = index;

      dots.forEach(function (d) { d.classList.remove('is-active'); });
      dot.classList.add('is-active');

      if (heroTitle) heroTitle.style.opacity = 0;
      if (heroTag) heroTag.style.opacity = 0;

      setTimeout(function () {
        if (heroTag) { heroTag.textContent = dot.dataset.tagline || ''; heroTag.style.opacity = 1; }
        if (heroTitle && dot.dataset.title) { revealWords(heroTitle, dot.dataset.title); heroTitle.style.opacity = 1; }
        if (heroCta && dot.dataset.link) { heroCta.href = dot.dataset.link; }

        if (heroImg && dot.dataset.img) {
          var probe = new Image();
          probe.crossOrigin = 'anonymous';
          probe.onload = function () {
            heroImg.classList.remove('is-visible');
            heroImg.src = dot.dataset.img;
            requestAnimationFrame(function () { heroImg.classList.add('is-visible'); });

            getDominantColor(probe, function (color) {
              if (heroOverlay) {
                heroOverlay.style.background = 'linear-gradient(0deg, ' + color.dark + 'cc 0%, ' + color.dark + '22 65%)';
              }
              if (heroGlow) {
                heroGlow.style.backgroundColor = color.base;
              }
              if (heroCta) {
                heroCta.style.background = color.base;
                heroCta.style.color = color.text;
              }
              applyGlobalTheme(color);
            });
          };
          probe.src = dot.dataset.img;
        }
      }, 200);
    }

    function nextSlide() {
      activate((current + 1) % dots.length);
    }

    function startAutoplay() {
      stopAutoplay();
      timer = setInterval(nextSlide, speed);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        activate(i);
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    if (heroCta) {
      heroCta.addEventListener('mousemove', function (e) {
        var rect = heroCta.getBoundingClientRect();
        var x = (e.clientX - rect.left - rect.width / 2) * 0.25;
        var y = (e.clientY - rect.top - rect.height / 2) * 0.25;
        heroCta.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      heroCta.addEventListener('mouseleave', function () {
        heroCta.style.transform = 'translate(0,0)';
      });
    }

    activate(0);
    startAutoplay();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["professional-footer"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[class*="pf-"] .pf-col-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (window.innerWidth > 749) return;
      var col = btn.closest('.pf-col-links');
      col.classList.toggle('is-open');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
